import React from 'react';


import { useDispatch, useSelector } from "react-redux";
import { setUserPropertyActionCreator } from '../actions';
import { userPropertiesSelector } from "../selectors";


export const useUserProperties = () => {
    const properties = useSelector(userPropertiesSelector);
    const dispatch = useDispatch();

    const setUserProperty = async (property, value) => {
        try{
           await dispatch(setUserPropertyActionCreator({
                property, 
                value
            }))
        }catch(err){

        }
    }

    return {
        properties,
        setUserProperty
    }
}